import NurseProfileError from './NurseProfileError'

export default class NurseSignupError extends NurseProfileError {
  email: string[] = []
  password1: string[] = []
  password2: string[] = []
}